(() => {
  const NS = 'http://www.w3.org/2000/svg';
  const node = (tag, attrs = {}, text) => {
    const el = document.createElementNS(NS, tag);
    Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const image = url => new Promise((resolve, reject) => {
    const img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img); img.onerror = reject; img.src = url;
  });
  function init() {
    document.querySelectorAll('[data-hc-product]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('form');
      const customArtwork = root.dataset.customArtwork === 'true';
      const options = Array.from(root.querySelectorAll('[data-hc-option]'));
      const order = root.querySelector('[data-hc-order]');
      const generate = root.querySelector('[data-hc-generate]');
      const status = root.querySelector('[data-hc-status]');
      const front = root.querySelector('[data-hc-front]');
      const strings = JSON.parse(root.querySelector('[data-hc-strings]').textContent);
      const read = name => form.elements.namedItem(`properties[${name}]`)?.value.trim() || '';
      const name = index => options[index].selectedOptions[0].dataset.name;
      const folded = () => name(0).startsWith('Folded');
      const size = () => {
        const selected = name(0);
        const dims = selected.includes('A2') ? [4.25, 5.5] : selected.includes('A6') ? [4.5, 6.125] : [5, 7];
        return root.dataset.horizontal === 'true' ? dims.reverse() : dims;
      };
      let controller, selectionRevision = 0, editRevision = 0, busy = false;
      const invalidate = () => {
        editRevision++;
        root.querySelectorAll('[data-hc-preview-file]').forEach(input => { input.value = ''; });
        status.textContent = strings.pending;
      };
      function presentation() {
        root.classList.toggle('hc-folded', folded());
        root.querySelector('[data-hc-outside-panel]').hidden = !folded();
        root.querySelector('[data-hc-front-panel]').hidden = folded();
        root.querySelector('[data-hc-back-panel]').hidden = folded();
        root.querySelector('[data-hc-folded-mock]').hidden = !folded();
        const horizontal = root.dataset.horizontal === 'true';
        root.querySelector('[data-hc-inside-first-label]').textContent = horizontal ? strings.inside_top : strings.inside_left;
        root.querySelector('[data-hc-inside-second-label]').textContent = horizontal ? strings.inside_bottom : strings.inside_right;
        root.querySelectorAll('.hc-panel-labels').forEach(labels => labels.classList.toggle('hc-vertical-labels', horizontal));
        root.querySelector('[data-hc-format-heading]').textContent = folded() ? strings.folded_heading : strings.flat_heading;
        root.querySelector('[data-hc-format-summary]').textContent = folded() ? strings.folded_description : strings.flat_description;
        root.querySelector('[data-hc-inside-panel]').hidden = !folded();
        root.querySelector('[data-hc-back-label]').textContent = folded() ? strings.back : strings.flat_back;
        root.querySelector('[data-hc-logo-label]').textContent = folded() ? strings.back_logo : strings.flat_logo;
        const placement = root.querySelector('[data-hc-finish-placement]');
        placement.hidden = name(1) === 'Standard';
        const backFinish = placement.querySelector('input[name="properties[Finish on back logo]"]');
        backFinish.closest('label').hidden = !folded();
        if (!folded()) backFinish.checked = false;
        placement.querySelectorAll('input').forEach(input => { input.disabled = placement.hidden || (input === backFinish && !folded()); });
        root.querySelector('[data-hc-front-finish-label]').textContent = folded() ? strings.folded_finish_label : strings.flat_finish_label;
        const finishRule = folded() ? strings.folded_finish_rule : strings.flat_finish_rule;
        root.querySelector('[data-hc-placement-note]').textContent = finishRule;
        root.querySelector('[data-hc-finish-rule]').textContent = finishRule;
        const finishLabel = name(1) === 'Standard' ? strings.standard_label : name(1) === 'Foil' ? strings.foil_label : strings.gloss_label;
        root.querySelector('[data-hc-price-summary]').textContent = `${name(2)} ${strings.cards_label} · ${name(0)} · ${finishLabel}`;
        const prefix = `${folded() ? 'Folded' : 'Flat'} ${name(1)} front`;
        const images = Array.from(root.querySelectorAll('[data-hc-image]'));
        const thumb = images.find(el => el.dataset.hcImageAlt.startsWith(prefix)) || (root.dataset.photo === 'true' ? images.find(el => el.dataset.hcImageAlt.startsWith(`Flat ${name(1)} front`)) : null);
        if (thumb) { front.src = thumb.dataset.hcImage; front.alt = thumb.dataset.hcImageAlt; }
        outsideSpread();
      }
      function outsideSpread() {
        if (!folded()) return;
        const back = root.querySelector('[data-hc-back] svg');
        if (!back) return;
        const h = 700 * size()[1] / size()[0];
        const horizontal = root.dataset.horizontal === 'true';
        const spread = node('svg', {xmlns:NS, width:horizontal ? 700 : 1400, height:horizontal ? h * 2 : h, viewBox:`0 0 ${horizontal ? 700 : 1400} ${horizontal ? h * 2 : h}`, role:'img', 'aria-label':strings.outside});
        const backHeight = Number(back.getAttribute('viewBox').split(' ')[3]);
        const company = node('g', {transform:`scale(1 ${h / backHeight})`});
        Array.from(back.children).forEach(child => company.appendChild(child.cloneNode(true)));
        spread.appendChild(company);
        spread.appendChild(node('image', {href:front.src,x:horizontal ? 0 : 700,y:horizontal ? h : 0,width:700,height:h,preserveAspectRatio:'xMidYMid meet'}));
        spread.appendChild(node('path', {d:horizontal ? `M 0 ${h} H 700` : `M 700 0 V ${h}`,stroke:'#aaa','stroke-dasharray':'8 8'}));
        root.querySelector('[data-hc-outside]').replaceChildren(spread);
        const mockHeight = 280 * size()[1] / size()[0];
        const mock = node('svg', {xmlns:NS,viewBox:`0 0 720 ${mockHeight + 130}`,role:'img','aria-label':strings.folded_view});
        mock.appendChild(node('ellipse', {cx:350,cy:mockHeight+90,rx:245,ry:18,fill:'#000',opacity:'.08'}));
        mock.appendChild(node('path', {d:`M 320 30 L 100 85 L 100 ${mockHeight+85} L 320 ${mockHeight+30} Z`,fill:'#fff',stroke:'#d4d4d4','stroke-width':2}));
        const cover = node('g', {transform:'matrix(1 .12 0 1 320 30)'});
        cover.appendChild(node('rect', {width:280,height:mockHeight,fill:'#fff',stroke:'#ddd'}));
        cover.appendChild(node('image', {href:front.src,width:280,height:mockHeight,preserveAspectRatio:'xMidYMid meet'}));
        mock.appendChild(cover);
        root.querySelector('[data-hc-folded-mock-art]').replaceChildren(mock);
      }
      async function variant() {
        const revision = ++selectionRevision;
        if (controller) controller.abort();
        controller = new AbortController(); order.disabled = true;
        presentation(); invalidate();
        const url = location.pathname === '/products_preview' ? new URL(location.href) : new URL(root.dataset.productUrl, location.origin);
        url.searchParams.delete('variant');
        url.searchParams.set('section_id', root.dataset.sectionId);
        url.searchParams.set('option_values', options.map(option => option.value).join(','));
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        try {
          let selected;
          if (location.pathname === '/products_preview') {
            // Shopify's private draft route does not resolve Section Rendering option selections.
            const response = await fetch(root.dataset.draftVariants, {signal: controller.signal});
            if (!response.ok) throw new Error('selection');
            const variants = await response.json();
            const match = variants.find(item => item.options.every((value, index) => value === name(index)));
            if (!match) throw new Error('selection');
            selected = {id: match.id, available: true, price: `$${Number(match.price).toFixed(2)} CAD`};
          } else {
            const response = await fetch(url, {signal: controller.signal});
            if (!response.ok) throw new Error('selection');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            selected = JSON.parse(doc.querySelector('[data-hc-selected]').textContent);
            if (revision !== selectionRevision) return;
            const quantities = doc.querySelector('[data-hc-option][data-position="3"]');
            if (quantities) Array.from(options[2].options).forEach(option => {
              const priced = Array.from(quantities.options).find(value => value.value === option.value);
              if (priced) option.textContent = priced.textContent;
            });
          }
          if (revision !== selectionRevision) return;
          if (!selected.id) throw new Error('selection');
          root.querySelector('[data-hc-variant]').value = selected.id;
          root.querySelector('[data-hc-price]').textContent = selected.price.replace(/\s*CAD$/, '');
          order.disabled = !selected.available;
          status.textContent = '';
          const current = new URL(location.href); current.searchParams.set('variant', selected.id);
          history.replaceState({}, '', current);
        } catch (error) {
          if (error.name !== 'AbortError' && revision === selectionRevision) status.textContent = strings.variant_error;
        }
      }
      options.forEach(option => option.addEventListener('change', variant));
      form.addEventListener('input', event => {
        if (!event.target.matches('[data-hc-option],[data-hc-preview-file]')) invalidate();
      });
      form.addEventListener('change', event => {
        if (event.target.type === 'file' && !event.target.hasAttribute('data-hc-preview-file')) invalidate();
      });
      root.querySelectorAll('[data-hc-image]').forEach(thumb => thumb.addEventListener('click', () => {
        front.src = thumb.dataset.hcImage; front.alt = thumb.dataset.hcImageAlt;
        outsideSpread();
      }));
      function textBlock(svg, text, y, height, maxSize = 32) {
        if (!text) return;
        const measure = document.createElement('canvas').getContext('2d');
        let lines, fontSize;
        for (fontSize = maxSize; fontSize >= 12; fontSize--) {
          measure.font = `${fontSize}px Georgia`;
          lines = [];
          text.split(/\r?\n/).forEach(paragraph => {
            let line = '';
            paragraph.split(/\s+/).forEach(word => {
              for (const character of word + ' ') {
                if (measure.measureText(line + character).width > 510) { lines.push(line.trim()); line = ''; }
                line += character;
              }
            }); lines.push(line.trim());
          });
          if (lines.length * fontSize * 1.4 <= height) break;
        }
        if (fontSize < 12) throw new Error('fit');
        const textNode = node('text', {x:350, y, 'text-anchor':'middle', 'font-family':'Georgia, serif', 'font-size':fontSize, fill:'#242424'});
        lines.forEach((line, index) => textNode.appendChild(node('tspan', {x:350, dy:index ? fontSize * 1.4 : 0}, line)));
        svg.appendChild(textNode);
      }
      async function logo() {
        const file = form.elements.namedItem('properties[Artwork]')?.files[0];
        if (!file || root.dataset.photo === 'true') return null;
        if (!/^image\/(png|jpeg|webp)$/.test(file.type)) { status.textContent = strings.artwork_note; return null; }
        if (file.size > 20 * 1024 * 1024) throw new Error('size');
        const url = URL.createObjectURL(file);
        try {
          const img = await image(url);
          const canvas = document.createElement('canvas');
          const scale = Math.min(1, 1200 / Math.max(img.naturalWidth, img.naturalHeight));
          canvas.width = Math.max(1, Math.round(img.naturalWidth * scale)); canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          return {url:canvas.toDataURL(), width:canvas.width, height:canvas.height};
        } finally { URL.revokeObjectURL(url); }
      }
      function draw(kind, artwork, sample) {
        const dims = size(), h = 700 * dims[1] / dims[0];
        const inside = kind === 'inside';
        const horizontal = root.dataset.horizontal === 'true';
        const w = inside && !horizontal ? 1400 : 700;
        const fullH = inside && horizontal ? h * 2 : h;
        const svg = node('svg', {xmlns:NS, viewBox:`0 0 ${w} ${fullH}`, width:w, height:fullH, role:'img', 'aria-label':inside ? strings.inside : strings.back});
        svg.appendChild(node('rect', {width:w,height:fullH,fill:'#fff'}));
        const panel = node('g', {transform:inside ? `translate(${horizontal ? 0 : 700} ${horizontal ? h : 0})` : 'translate(0 0)'});
        svg.appendChild(panel);
        panel.appendChild(node('path', {d:`M 60 75 H 150 M 60 75 V 165 M 640 ${h-75} H 550 M 640 ${h-75} V ${h-165}`, stroke:'#c4cbbf', 'stroke-width':3,fill:'none'}));
        const choice = form.querySelector('[data-holiday-message-choice]');
        const greeting = choice?.selectedIndex > 0 ? choice.selectedOptions[0].dataset.message : read('Message');
        const showMessage = inside || !folded();
        const showCompany = !inside;
        if (showMessage) textBlock(panel, greeting || (sample ? strings.sample : ''), h * .30, h * (folded() ? .36 : .24));
        if (inside) textBlock(panel, read('Your Name'), h * .77, h * .12, 25);
        if (showCompany) {
          const logoY = folded() ? .27 : .59;
          if (artwork && !customArtwork) {
            const scale = Math.min(220 / artwork.width, h * .18 / artwork.height);
            const aw = artwork.width * scale, ah = artwork.height * scale;
            panel.appendChild(node('image', {href:artwork.url,x:350-aw/2,y:h*logoY-ah/2,width:aw,height:ah}));
          }
          const identity = [!folded() ? read('Your Name') : '', read('Company Name')].filter(Boolean).join('\n');
          const contacts = [read('Address Line 1'),read('Address Line 2'),[read('Phone Number'),read('Email')].filter(Boolean).join(' · ')].filter(Boolean).join('\n');
          textBlock(panel, identity || (sample ? strings.company_sample : ''), h * (folded() ? .49 : .75), h * .13, 25);
          textBlock(panel, contacts, h * (folded() ? .65 : .87), h * .12, 19);
        }
        if (inside) svg.appendChild(node('path', {d:horizontal ? `M 0 ${h} H 700` : `M 700 0 V ${h}`,stroke:'#aaa','stroke-dasharray':'8 8','data-hc-fold-guide':''}));
        return svg;
      }
      async function exportFile(svg, kind) {
        const print = svg.cloneNode(true); print.querySelector('[data-hc-fold-guide]')?.remove();
        const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(print)], {type:'image/svg+xml'}));
        try {
          const img = await image(url), dims = size(), canvas = document.createElement('canvas');
          const inside = kind === 'inside', horizontal = root.dataset.horizontal === 'true';
          canvas.width = Math.round(dims[0] * 300 * (inside && !horizontal ? 2 : 1));
          canvas.height = Math.round(dims[1] * 300 * (inside && horizontal ? 2 : 1));
          canvas.getContext('2d').drawImage(img,0,0,canvas.width,canvas.height);
          const blob = await new Promise(resolve => canvas.toBlob(resolve,'image/png'));
          if (!blob) throw new Error('export');
          return new File([blob],`holiday-${kind}-preview.png`,{type:'image/png'});
        } finally { URL.revokeObjectURL(url); }
      }
      generate.addEventListener('click', async () => {
        if (busy || !form.reportValidity()) return;
        busy = true; generate.disabled = true; const revision = editRevision;
        try {
          await document.fonts.ready; status.textContent = '';
          const artwork = await logo();
          const warning = status.textContent;
          if (customArtwork) {
            front.src = artwork ? artwork.url : root.dataset.placeholderImage;
            front.alt = artwork ? 'Your uploaded holiday card artwork' : 'Upload Your Own File';
          }
          const panels = folded() ? ['inside','back'] : ['back'];
          const results = await Promise.all(panels.map(async kind => {
            const svg = draw(kind,artwork,false); return {kind,svg,file:await exportFile(svg,kind)};
          }));
          if (revision !== editRevision) return;
          results.forEach(({kind,svg,file}) => {
            root.querySelector(`[data-hc-${kind}]`).replaceChildren(svg);
            const transfer = new DataTransfer(); transfer.items.add(file);
            root.querySelector(`[data-hc-preview-file="${kind}"]`).files = transfer.files;
          });
          outsideSpread();
          const choice = form.querySelector('[data-holiday-message-choice]');
          if (choice?.selectedIndex > 0) form.elements.namedItem('properties[Message]').value = choice.selectedOptions[0].dataset.message;
          status.textContent = strings.ready + (warning ? ' ' + warning : '');
        } catch (error) { invalidate(); status.textContent = strings.error; }
        finally {busy = false; generate.disabled = false;}
      });
      const dialog = root.querySelector('[data-hc-dialog]');
      root.querySelectorAll('[data-hc-zoom]').forEach(button => button.addEventListener('click', () => {
        const content = button.querySelector('img,svg'); if (!content) return;
        root.querySelector('[data-hc-zoom-content]').replaceChildren(content.cloneNode(true)); dialog.showModal();
      }));
      root.querySelector('[data-hc-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {if(event.target === dialog) dialog.close();});
      form.addEventListener('submit', event => {
        if (order.disabled || busy) {event.preventDefault(); return;}
        const choice = form.querySelector('[data-holiday-message-choice]');
        if (choice?.selectedIndex > 0) form.elements.namedItem('properties[Message]').value = choice.selectedOptions[0].dataset.message;
      });
      const initial = new URL(location.href).searchParams;
      let changed = false;
      [['card_format',0],['finish',1]].forEach(([parameter,index]) => {
        const value = initial.get(parameter);
        if (!value) return;
        const target = Array.from(options[index].options).find(option => index === 0 ? option.dataset.name.startsWith(value + ' /') : option.dataset.name === value);
        if (target) { options[index].value = target.value; changed = true; }
      });
      const lockedFormat = folded() ? 'Folded' : 'Flat';
      if (!customArtwork) Array.from(options[0].options).forEach(option => {
        if (!option.dataset.name.startsWith(lockedFormat + ' /')) option.remove();
        else option.textContent = option.dataset.name.split(' / ')[1];
      });
      const currentContext = new URL(location.href);
      if (!customArtwork) currentContext.searchParams.set('card_format', lockedFormat);
      history.replaceState({}, '', currentContext);
      root.querySelectorAll('[data-hc-image]').forEach(thumb => {thumb.hidden = !(thumb.dataset.hcImageAlt.startsWith(lockedFormat + ' ') || (root.dataset.photo === 'true' && thumb.dataset.hcImageAlt.startsWith('Flat ')));});
      presentation();
      if (changed) variant();
      root.querySelector('[data-hc-inside]').replaceChildren(draw('inside',null,true));
      root.querySelector('[data-hc-back]').replaceChildren(draw('back',null,true));
      outsideSpread();
      if (root.dataset.photo === 'true') status.textContent = strings.photo_note;
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();

